import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'lowercase'
})
export class LowercasePipe implements PipeTransform {
	transform(_value: any, _args?: unknown): any {
		return null;
	}
}
